import { OfferLinkProps } from './types';

export const root = '/insurances';

export const coverage = `${root}/coverage`;
export const offers = `${root}/offers`;

export const getOfferPath = (id: string) => `${offers}/${id}`;

const INSURANCE_TOOLBOX_TAG_ID = 'YegyzxEAAB8AptQN';

export const fromPartners: OfferLinkProps = {
  pathname: '/toolbox/offers',
  search: `?tagsIds[0]=${INSURANCE_TOOLBOX_TAG_ID}`,
};

export const rentalVehicle: OfferLinkProps = {
  pathname: getOfferPath('rental-vehicle'),
};

export const recoveryAssistance: OfferLinkProps = {
  pathname: getOfferPath('recovery-assistance'),
};

export const paymentFraud: OfferLinkProps = {
  pathname: getOfferPath('payment-fraud'),
};

export const phishing: OfferLinkProps = {
  pathname: getOfferPath('phishing'),
};

export const purchaseProtection: OfferLinkProps = {
  pathname: getOfferPath('purchase-protection'),
};

export const hospitalization: OfferLinkProps = {
  pathname: getOfferPath('hospitalization'),
};

export const transportDelay: OfferLinkProps = {
  pathname: getOfferPath('transport-delay'),
};

export const healthCostsAbroad: OfferLinkProps = {
  pathname: getOfferPath('health-costs-abroad'),
};

export const accidentCoverage: OfferLinkProps = {
  pathname: getOfferPath('accident-coverage'),
};

export const computerBreakage: OfferLinkProps = {
  pathname: getOfferPath('computer-breakage'),
};

export const debtRecovery: OfferLinkProps = {
  pathname: getOfferPath('debt-recovery'),
};

export const legalAssistance: OfferLinkProps = {
  pathname: getOfferPath('legal-assistance'),
};

export const mobileScreen: OfferLinkProps = {
  pathname: getOfferPath('mobile-screen'),
};

export const warrantyExtension: OfferLinkProps = {
  pathname: getOfferPath('warranty-extension'),
};
